<template>
  <div class="createQuestion" v-if="tag === 'normal'">
    <div class="problemView">
        <label class="text"><span class="star">*</span>标题</label>
        <div class="titleWrapper">
          <span class="input">
            <input placeholder="限50字" v-model="title" maxlength="50"/>
          </span>
          <img class="photo" :src="`${image ? image : images.photo}`" @click="uploadPhoto(-1)"/>
        </div>
    </div>
    <div class="optionView">
        <label class="text"><span class="star">*</span>选项</label>
        <div class="options">
            <div class="option" v-for="(item, index) in options" :key="index">
                <div class="optionWrapper">
                    <span class="number">{{String.fromCharCode(65+index)}}</span>
                    <span class="input"><input maxlength="50" placeholder="限50字" v-model="item.message"/></span>
                    <img class="photo" :src="`${item.image ? item.image : images.photo}`" @click="uploadPhoto(index)"/>
                </div>
                <img class="selectIcon" :src="`${item.is_answer ? images.select : images.unselect}`" @click="setAnswerNumber(index)" />
                <span class="deleteIcon" @click="removeOptionEvent(index)"><span class="line"></span></span>
            </div>
            <div class="addOption" @click="addOptionEvent()">
                <span class="addIcon">
                  <span class="line1"></span>
                  <span class="line2"></span>
                </span>
                添加选项
            </div>
        </div>
        <input
          ref="uploadPhoto"
          required
          accept="image/*"
          type="file"
          style="display:none;"
          @change="uploadPhoto_change"
        />
    </div>
    <div class="answerView">
        <label class="text"><span class="star">*</span>正确答案</label>
        <span class="input">
            <input disabled placeholder="" :value="`${getAnswerNumber()}`"/>
        </span>
    </div>
    <div class="diamondView">
      <label class="text">奖励蓝钻</label>
      <div class="diamondWrapper">
        <div class="diamondType">
          <span class="common" @click="setDiamondType('common')">
            <img class="icon" :src="`${diamond.type === 'common' ? images.select : images.unselect}`" />
            普通
          </span>
          <!-- <span class="luck" @click="setDiamondType('luck')">
            <img class="icon" :src="`${diamond.type === 'luck' ? images.select : images.unselect}`" />
            拼手气
          </span> -->
        </div>
        <div class="diamondNumber">
          <div class="value">
              <span class="title">单个数量:</span>
              <!-- 计数器 -->
              <div class="counterView">
                <span class="subtract" @click="counterEvent('subtract', 'value')">-</span>
                <span class="input">
                    <input placeholder="0" v-model="diamond.value" @keyup="counterInputEvent('value')"/>
                </span>
                <span class="add" @click="counterEvent('add', 'value')">+</span>
              </div>
          </div>
          <div class="count">
              <span class="title">个数:</span>
              <!-- 计数器 -->
              <div class="counterView">
                <span class="subtract" @click="counterEvent('subtract', 'count')">-</span>
                <span class="input">
                    <input placeholder="0" v-model="diamond.count" @keyup="counterInputEvent('count')"/>
                </span>
                <span class="add" @click="counterEvent('add', 'count')">+</span>
              </div>
          </div>
        </div>
        <span class="diamondTip">先到先得，答对才有蓝钻</span>
      </div>
    </div>
    
    <span class="submit" @click="submit()">提交</span>
  </div>
  <div v-else-if="show_shadow_view" class="createQuestionShadow" @click.self="hideShadowView()">
    <div class="createQuestionView">
      <span class="close" @click="hideShadowView()">
        <span class="line1"></span>
        <span class="line2"></span>
      </span>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { 
  IMG_QUESTION_PHOTO, 
  IMG_QUESTION_ADD, 
  IMG_QUESTION_SUB, 
  IMG_QUESTION_SELECT, 
  IMG_QUESTION_UNSELECT 
} from '../../assets';
import { UPLOAD_SINGLE_IMAGE, GET_VALUE, SET_VALUE } from '../../utils';

import { types as ToastTypes } from "../../store/modules/toast";
import { types as CommunityTypes } from "../../store/modules/community";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "CreateQuestion",
  components: {},
  props: {
    tag: {
      type: String,
      default: 'normal'
    }
  },
  data() {
    return {
      images:{
        photo: IMG_QUESTION_PHOTO,
        add: IMG_QUESTION_ADD,
        sub: IMG_QUESTION_SUB,
        select: IMG_QUESTION_SELECT,
        unselect: IMG_QUESTION_UNSELECT,
      },
      show_shadow_view: false,
      // 蓝钻类型
      diamond:{
        type: "common",
        value:0,
        count:0
      },
      // 标题
      title: "",
      // 标题图片
      image: "",
      // 选项
      // { "message":"选项 2", "imgs":[]}
      options:[
        {"message":"", "image":"", "is_answer":false},
        {"message":"", "image":"", "is_answer":false},
        {"message":"", "image":"", "is_answer":false}
      ],
      // 答案
      answers:[]
    };
  },
  watch: {},
  computed: {
    ...mapState({
      userInfo: state => state.login.userInfo
    })
   
  },
  methods: {
    ...mapMutations({
      showToast: ToastTypes.SHOW
    }),
    ...mapActions({
      fetchCreateQuestion: CommunityTypes.FETCH_CREATE_QUESTION
    }),

    //设置蓝钻类型
    setDiamondType(type){
      this.diamond.type = type;
    },
    // 设置正确选项
    setAnswerNumber(index){
      if(this.options[index].message !== "" || this.options[index].image !== ""){
        // 将选项置为非答案(只能单选)
        this.options.map(item=>item['is_answer']=false)
        this.options[index]["is_answer"] = !this.options[index].is_answer;
      }else{
        this.showToast({"message":"当前选项没有内容"})
      }
    },
    // 新增一条空白选项
    addOptionEvent(){
      if(this.options.length < 5){
        var dic = {"message":"", "image":"", "is_answer":false}
        this.options.push(dic);
      }else{
        this.showToast({"message":"最多只能出5个选项"})
      }
    },
    // 删除选项
    removeOptionEvent(index){
      this.options.splice(index, 1);
    },
    // 获取正确答案编号
    getAnswerNumber(){
      var answers = [];
      this.options.map((item,index)=>{
        if(item.is_answer && !answers.includes(String.fromCharCode(65+index))){
          answers.push(String.fromCharCode(65+index))
        }
      })
      return answers.join(",")
    },
    // 计数器输入框事件
    counterInputEvent(tag){
      let value = tag === 'value' ? this.diamond.value : this.diamond.count;
      value = String(value)
      if(value.length === 1){
          value = value.replace(/[^1-9]/g, '')
      }else{
          value = value.replace(/\D/g, '')
      }
      if(value){
        value = parseInt(value);
      }else{
        value = 0
      }
      if(tag === 'value'){
        this.diamond.value = value;
      }else if(tag === 'count'){
        this.diamond.count = value;
      }
    },
    // 计数器加减事件
    counterEvent(tag, counterType){
      // console.log(tag, counterType);
      let number = 0;
      if(counterType === 'value'){
        number = this.diamond.value
      }else if(counterType === 'count'){
        number = this.diamond.count
      }
            
      if(tag === 'add'){
        number += 1;
      }else if(tag === 'subtract'){
        number -= 1;
      }
      if(number < 0){
        number = 0;
      }
      
      if(counterType === 'value'){
        this.diamond.value = number;
      }else if(counterType === 'count'){
        this.diamond.count = number;
      }
    },
    // 确定事件
    submit(){
      if(this.title === ""){
        this.showToast({"message":"请输入标题"})
        return
      }
      let options = this.options.filter((item, index) => {
        return item.message !== "" || item.image !== ""
      })
      if(!options.length){
        this.showToast({"message":"请设置一些选项内容"})
        return
      }

      let answers = []
      options.map((item,index)=>{
        let number = String.fromCharCode(65+index)
        if(item.is_answer && !answers.includes(number)){
          answers.push(number)
        }
      })
      if(!answers.length){
        this.showToast({"message":"请设置正确选项"})
        return
      }

      let new_options = [];
      options.map((item, index) => {
        let number = String.fromCharCode(65+index)
        let new_item = {...item, "number": number}
        new_options.push(new_item)
      })

      let question_json = {
        "type":"adaptProblem",
        "message": this.title,
        "image": this.image,
        "options": new_options,
        "answer": answers,
        "diamond": this.diamond
      }
      let dic = {"question_json":JSON.stringify(question_json), "content":"回答问题"}
      // 发帖(习题)
      // 15 分钟限制
      console.log("发帖 15 分钟限制--判断")
      var time_str = GET_VALUE("lastSendPostTime")
      if(!this.userInfo.is_staff && time_str){
        var last_time = new Date(time_str)
        var current_time = new Date()
        var seconds = parseInt((current_time - last_time) / 1000)
        if(seconds > 0 && seconds <= 15*60){
          // 提示15分钟内只能发送一条信息
          // console.log("false")
          console.log("发帖 15 分钟限制--停止发帖")
          this.showToast({"message":"15分钟内只能发一条帖子"})
          return
        }
        console.log("发帖 15 分钟限制--开始发")
        localStorage["lastSendPostTime"] = new Date();
      }

      this.fetchCreateQuestion(dic);
      if(this.$parent.hideShadowView){
        this.$parent.hideShadowView()
      }
    },
    // 上传 logo 图点击事件
    uploadPhoto(index){
      this.currentOptionIndex = index;
      this.$refs.uploadPhoto.click();
    },
    uploadPhoto_change(e){
      let files = e.target.files;
      let imgSrc = window.URL.createObjectURL(files[0]);
      // this.options[this.currentOptionIndex]["image"] = imgSrc;
      // console.log(imgSrc, files[0])

      UPLOAD_SINGLE_IMAGE(files[0], (url)=>{
        // this.logo.remoteUrl = url;
        if(this.currentOptionIndex === -1){
          // 题目图片
          this.image = url;
        }else{
          // 选项图片
          this.options[this.currentOptionIndex]["image"] = url;
        }
      }, (progress)=>{
        // this.logo.progress = parseInt(progress);
      })
    },

    // -----shadow 事件
    showShadowView(){
      this.show_shadow_view = true
    },
    hideShadowView(){
      this.show_shadow_view = false
    },
  },
  created() {},
  destroyed() {},
  mounted() {
    
  }
};
</script>

<style lang="less" scoped>
.createQuestion {
  background-color: #ffffff;
  border: solid 5px #6B45E1;
  padding: 25px;
  padding-top: 15px;
  border-radius: 5px;
  overflow: auto;
  max-height: 500px;
  .problemView{
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;
    .text{
      color: #333333;
      font-size: 14px;
      margin-right: 10px;
      .star{
        color: #DE0000;
        margin-right: 2px;
      }
    }
    .titleWrapper{
      flex: 1;
      height: 30px;
      background-color: #f2f2f5;
      border: solid 1px #EBEBEB;
      padding: 0 5px;
      border-radius: 3px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .input{
        flex: 1;
        input{
          border: none;
          width: 100%;
          height: 100%;
          background-color: transparent;
        }
      }
      .photo{
        width: 20px;
        cursor: pointer;
        max-height: 20px;
        margin-left: 5px;
      }
    }
  }
  .optionView{
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;
    .text{
      color: #333333;
      font-size: 14px;
      margin-right: 10px;
      .star{
        color: #DE0000;
        margin-right: 2px;
      }
    }
    .options{
      flex: 1;
      .option{
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 10px;
        .deleteIcon{
          width: 20px;
          height: 20px;
          margin-left: 10px;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          .line{
            width: 90%;
            height: 2px;
            background-color: red;
          }
        }
        .optionWrapper{
          flex: 1;
          display: flex;
          flex-direction: row;
          align-items: center;
          height: 30px;
          background-color: #f2f2f5;
          border: solid 1px #EBEBEB;
          padding: 0 5px;
          border-radius: 3px;
          .number{
            color: #774EE5;
            font-size: 14px;
            margin-right: 5px;
          }
          .input{
            flex: 1;
            input{
              border: none;
              width: 100%;
              height: 100%;
              background-color: transparent;
            }
          }
          .photo{
            width: 20px;
            cursor: pointer;
            max-height: 20px;
            margin-left: 5px;
          }
        }
        .selectIcon{
          width: 20px;
          margin-left: 10px;
          cursor: pointer;
        }
      }
      .addOption{
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #774EE5;
        font-size: 14px;
        cursor: pointer;
        .addIcon{
          width: 18px;
          height: 18px;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 5px;
          cursor: pointer;
          .line1 {
            position: absolute;
            width: 80%;
            height: 2px;
            background-color: #644ed9;
            top: calc(50% - 1px);
          }
          .line2 {
            width: 2px;
            height: 80%;
            background-color: #644ed9;
          }
        }
      }
    }
  }
  .answerView{
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;
    .text{
      color: #333333;
      font-size: 14px;
      margin-right: 10px;
      .star{
        color: #DE0000;
        margin-right: 2px;
      }
    }
    .input{
      flex: 1;
      height: 30px;
      background-color: #f2f2f5;
      border: solid 1px #EBEBEB;
      padding: 0 5px;
      border-radius: 3px;
      input{
        border: none;
        width: 100%;
        height: 100%;
        background-color: transparent;
      }
    }
  }
  .diamondView{
    display: flex;
    flex-direction: row;
    margin-top: 20px;
    font-size: 14px;
    .text{
      font-size: 14px;
      color: #333333;
      margin-right: 10px;
    }
    .diamondWrapper{
      flex:1;
      .diamondType{
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 10px;
        .common,
        .luck{
          display: flex;
          flex-direction: row;
          align-items: center;
          font-size: 13px;
          .icon{
            width: 15px;
            margin-right: 5px;
          }
        }
        .common{
          margin-right: 30px;
        }
      }
      .diamondNumber{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .value,
        .count{
          display: flex;
          flex-direction: row;
          align-items: center;
          // margin-right: 40px;
          .title{
            font-size:13px; 
            margin-right: 10px;
            display: inline-block;
          }
        }
        .value{
          
        }
      }
      .diamondTip{
        margin-bottom: 10px;
        margin-top: 10px;
        font-size: 12px;
        color: #666666;
        display: block;
      }
      .counterView{
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        color: #6B45E1;
        font-size: 26px;
        .add{
          cursor: pointer;
        }
        .input{
          border: solid 1px #ebebeb;
          height: 25px;
          display: flex;
          padding: 0 5px;
          margin: 0 5px;
          background-color: #F2F2F5;
          border-radius: 3px;
          width: 50px;
          input{
            background-color: transparent;
            border: none;
            width: 100%;
            height: 100%;
          }
        }
        .subtract{
          cursor: pointer;
        }
      }
    }
  }
  .submit {
    width: 70px;
    height: 30px;
    border-radius: 15px;
    background-color: #774EE5;
    color: #ffffff;
    font-size: 14px;
    display: inline-block;
    line-height: 30px;
    text-align: center;
    margin-left: calc(50% - 35px);
    cursor: pointer;
    margin-top: 20px;
  }
}
.createQuestionShadow{
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 9999;
  position: fixed;
  overflow: auto;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .createQuestionView{
    width: 60%;
    border-radius: 5px;
    position: relative;
    .close {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background-color: #ffffff;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      position: absolute;
      right: -50px;
      top:0;
      transform: rotate(45deg);
      .line1 {
        position: absolute;
        width: 20px;
        height: 1.5px;
        background-color: #644ed9;
        top: calc(50% - 1px);
      }
      .line2 {
        width: 1.5px;
        height: 20px;
        background-color: #644ed9;
      }
    }
  }
}
</style>
